<template>
  <div class="pa-2">
    <section class="cargo-hierarchy-card">
      <div class="pa-4">
        <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
          <div class="d-flex">
            <div class="mr-4">
              <span class="font-weight-bold"> Carga: </span>
              <span class="font-weight-regular"> {{ cargo.cargoNumber }} </span>
            </div>
            <div v-if="cargo.isDirectDelivery" class="mr-4">
              <span class="font-weight-bold">Entrega Direta</span>
            </div>
            <div v-else class="mr-4">
              <span class="font-weight-bold">Transbordo: </span>
              <TruncateDataWithTooltip
                :data="cargo.transhipmentName"
                :lengthDataToTruncate="truncateLimit"
              ></TruncateDataWithTooltip>
            </div>
          </div>
          <div class="d-flex">
            <v-icon @click="toggleCollapsed">
              {{ isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
            </v-icon>
          </div>
        </v-card-text>

        <v-card-text class="d-flex pa-0">
          <v-col class="pa-0" cols="12" md="12">
            <span class="font-weight-bold text--secondary">Valor das mercadorias: </span>
            <span class="font-weight-regular mr-4">{{
              formatPrice(cargo.totalPriceNfes || cargo.TotalPriceNfes)
            }}</span>
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular mr-4"
              >{{ formatWeight(cargo.weightDeliveries || cargo.WeightDeliveries || 0) }}kg</span
            >
            <span class="font-weight-bold text--secondary">Quantidade de paradas: </span>
            <span class="font-weight-regular"> {{ cargo?.amountStops || cargo.AmountStops }} </span>
          </v-col>
        </v-card-text>
      </div>
      <v-data-table
        id="list02"
        class="w-100"
        v-if="isCollapsed"
        :headers="StopsHeaders"
        :items="alocatedStops"
        :items-per-page="alocatedStops.length"
        :loading="isLoadingAlocated"
        loading-text="Carregando..."
        hide-default-footer
      >
        <template #body="{}">
          <tbody>
            <template v-if="alocatedStops.length > 0">
              <tr v-for="item in alocatedStops" :key="item.id">
                <td>
                  {{ item?.stopNumber }}
                </td>
                <td v-if="!cargo.isDirectDelivery">{{ formatPrice(item?.transhipmentPrice) }}</td>
                <td>{{ formatPrice(item?.totalPriceNfes) }}</td>
                <td>{{ formatWeight(item?.weightDeliveries) }}kg</td>
                <td>
                  <TruncateDataWithTooltip
                    :data="item.nameRecipient"
                    :lengthDataToTruncate="truncateLimit"
                  ></TruncateDataWithTooltip>
                </td>
                <td>
                  <TruncateDataWithTooltip
                    :data="item.nameCityRecipient"
                    :lengthDataToTruncate="truncateLimit"
                  ></TruncateDataWithTooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="7" class="text-center">Nenhuma parada alocado para essa carga</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-data-table>
    </section>
  </div>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import maskPrice from '@/utils/maskPrice';
import copyToClipboard from '@/utils/copyToClipboard';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';

export default {
  components: {
    TruncateDataWithTooltip
  },
  props: {
    cargo: {
      default: () => ({}),
      type: Object
    },
    importedSuccessfully: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isCollapsed: false,
    alocatedStops: []
  }),
  computed: {
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    },
    StopsHeaders() {
      const baseHeaders = [
        { value: 'stopNumber', text: 'NÚMERO PARADA', sortable: true },
        { value: 'totalPriceNfes', text: 'VALOR MERCADORIAS', sortable: true },
        { value: 'weightDeliveries', text: 'PESO', sortable: true },
        { value: 'nameRecipient', text: 'DESTINATÁRIO', sortable: true },
        { value: 'transhipmentCity', text: 'CIDADE', sortable: true }
      ];
      if (!this.cargo.isDirectDelivery) {
        baseHeaders.splice(1, 0, { value: 'transhipmentPrice', text: 'FRETE TRANSBORDO', sortable: true });
      }
      return baseHeaders;
    }
  },
  methods: {
    ...mapActions('ImportManualCargosStore', ['getStopsByCargoId', 'allocateStop']),
    async toggleCollapsed() {
      this.isLoadingAlocated = true;
      try {
        if (!this.isCollapsed) {
          this.isCollapsed = !this.isCollapsed;
          const data = await this.getStopsByCargoId(this.cargo.id);
          this.alocatedStops = data;
        } else {
          this.isCollapsed = !this.isCollapsed;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingAlocated = false;
      }
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    }
  }
};
</script>

<style scoped>
.cargo-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
</style>
